var map = {
	"./Actualizable/1_objetivos.md": 44991,
	"./Actualizable/2_introduccionProxyUpgrades.md": 7602,
	"./Actualizable/3_descripcion.md": 24132,
	"./Actualizable2/1_objetivos.md": 35985,
	"./Actualizable2/2_descripcion.md": 44252,
	"./Actualizable3/1_objetivos.md": 50323,
	"./Actualizable3/2_descripcion.md": 23614,
	"./Actualizable4/1_objetivos.md": 23578,
	"./Actualizable4/2_descripcion.md": 25041,
	"./Aleatorio/1_objetivos.md": 44816,
	"./Aleatorio/2_descripcion.md": 77749,
	"./Bienvenida/1_bienvenida.md": 2184,
	"./Bienvenida/1_objetivos.md": 90901,
	"./Bienvenida/2_guia.md": 23662,
	"./Bloqueado/1_objetivos.md": 12191,
	"./Bloqueado/2_descripcion.md": 98322,
	"./CanjeImposible/1_objetivos.md": 54200,
	"./CanjeImposible/2_descripcion.md": 72226,
	"./DatosPrivados/1_objetivos.md": 35600,
	"./DatosPrivados/2_descripcion.md": 69431,
	"./Decompilar/1_objetivos.md": 75405,
	"./Decompilar/2_descripcion.md": 75982,
	"./Delegar/1_objetivos.md": 27207,
	"./Delegar/2_descripcion.md": 40841,
	"./Delegar/BACKUP.md": 45225,
	"./Denegacion/1_objetivos.md": 61310,
	"./Denegacion/2_descripcion.md": 10362,
	"./Denegacion2/1_objetivos.md": 25017,
	"./Denegacion2/2_descripcion.md": 92318,
	"./Desbordamiento/1_objetivos.md": 54634,
	"./Desbordamiento/2_descripcion.md": 37847,
	"./DesdeContrato/1_objetivos.md": 48032,
	"./DesdeContrato/2_guia.md": 69469,
	"./ErrorFatal/1_objetivos.md": 12866,
	"./ErrorFatal/2_descripcion.md": 89556,
	"./Jeroglifico/1_objetivos.md": 88512,
	"./Jeroglifico/2_descripcion.md": 47321,
	"./ManipularStorage/1_objetivos.md": 70102,
	"./ManipularStorage/2_descripcion.md": 52876,
	"./MisionEspacial/1_objetivos.md": 86230,
	"./MisionEspacial/2_descripcion.md": 76160,
	"./NombreConstructor/1_objetivos.md": 38491,
	"./NombreConstructor/2_descripcion.md": 9369,
	"./Pesca/1_objetivos.md": 3032,
	"./Pesca/2_descripcion.md": 55241,
	"./Puntero/1_objetivos.md": 86013,
	"./Puntero/2_descripcion.md": 57590,
	"./Reentrada/1_objetivos.md": 68508,
	"./Reentrada/2_descripcion.md": 23531,
	"./Reentrada2/1_objetivos.md": 72002,
	"./Reentrada2/2_descripcion.md": 7136,
	"./Reentrada3/1_objetivos.md": 11767,
	"./Reentrada3/2_descripcion.md": 13648,
	"./ReutilizandoValor/1_objetivos.md": 18048,
	"./ReutilizandoValor/2_descripcion.md": 82410,
	"./SaldoInesperado/1_objetivos.md": 8109,
	"./SaldoInesperado/2_descripcion.md": 26842,
	"./Token/1_objetivos.md": 90647,
	"./Token/2_guia.md": 12620,
	"./Trampa/1_objetivos.md": 88704,
	"./Trampa/2_descripcion.md": 44048,
	"./Transferencia/1_objetivos.md": 9653,
	"./Transferencia/2_guia.md": 81942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73053;